// components
import { GridCompact6 } from 'components/shared/Grid/Grid.components';
import SectionHeader from '../SectionHeader/SectionHeader';
import { Icon } from '@sdb/planning-ui';

// styles
import { SpacedBox } from '../../AppointmentForm.styles';

// hooks
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { type RefObject } from 'react';

// consts
import DateTimePeriodSection from './components/DateTimePeriodSection/DateTimePeriodSection';
import RecurrencePatternBuilder from '../RecurrencePatternBuilder/RecurrencePatternBuilder';

// types
import type { AppointmentFormFieldData } from '../../AppointmentForm.types';
import type { RecurrencePattern } from '../RecurrencePatternBuilder/RecurrencePatternBuilder.types';

type WhenSectionProps = {
  timeFieldRef?: RefObject<HTMLInputElement | null>;
};

const WhenSection = ({ timeFieldRef }: WhenSectionProps) => {
  'use memo';
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });

  const { control, setValue } = useFormContext<AppointmentFormFieldData>();
  const start = useWatch({ name: 'start', control });
  const end = useWatch({ name: 'end', control });
  const recurrencePattern = useWatch({ name: 'recurrencePattern', control });
  const allowedToEditRecurrenceRule = useWatch({
    name: 'allowedToEditRecurrenceRule',
    control
  });

  const id = useWatch({ name: 'id', control });
  const isExistingAppointment = !!id;

  const handlePatternChange = (pattern: RecurrencePattern) =>
    setValue('recurrencePattern', pattern, {
      shouldDirty: true,
      shouldValidate: true
    });

  return (
    <GridCompact6>
      <SectionHeader
        label={t('when')}
        icon={<Icon type="calendar" fontSize="inherit" />}
      />
      <SpacedBox>
        <DateTimePeriodSection timeFieldRef={timeFieldRef} />
        <RecurrencePatternBuilder
          date={start!}
          isExistingAppointment={isExistingAppointment}
          allowedToEditRecurrenceRule={allowedToEditRecurrenceRule}
          pattern={recurrencePattern}
          minPatternEnd={end!}
          onPatternChange={handlePatternChange}
        />
      </SpacedBox>
    </GridCompact6>
  );
};

export default WhenSection;
